module.exports = __webpack_public_path__ + "img/3.1227ce4d.svg";